 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		23: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"42cc45e1afd5c22ebd384bde16ceb87c1aa81319","1":"100c9062","2":"260a478cfc1d27045b55778b597bb4da3b8cfb66","3":"b01f64f3","4":"b637e9a5","5":"a09686f1","6":"b07aaa4f","7":"c031b301fca8fb1c46c26f2f947fd90f3d1ff232","8":"55bfca2627b7a7ff0389fc6d4452dbae3f006217","9":"4a754ec80b178711dc26cb30cefd4fcf6c941ecb","10":"05d954cf","11":"c929556b142d98b066b8861212010a9406a162c3","12":"e8cbb670aba452384e47764d95ca5be58beb1144","13":"framework","14":"5a6f9aa80bec0d55a61c485bbb4a741261969b63","15":"888c22908c6a1b8476a48b8f624821ab43919eb0","16":"component---src-pages-merchant-manageusers-create-js","17":"component---src-pages-merchant-manageusers-dashboard-js","18":"component---src-pages-merchant-manageusers-edit-js","19":"component---src-pages-merchant-statements-graphs-js","20":"component---src-pages-points-checkout-index-js","21":"component---src-pages-token-checkout-index-js","22":"component---src-pages-wallet-checkout-index-js","28":"component---src-pages-about-au-js","29":"component---src-pages-about-index-js","30":"component---src-pages-about-nz-js","31":"component---src-pages-checkout-js","32":"component---src-pages-embed-shopify-dashboard-js","33":"component---src-pages-error-js","34":"component---src-pages-index-js","35":"component---src-pages-info-js","36":"component---src-pages-merchant-analytics-index-js","37":"component---src-pages-merchant-home-index-js","38":"component---src-pages-merchant-index-js","39":"component---src-pages-merchant-login-callback-js","40":"component---src-pages-merchant-login-index-js","41":"component---src-pages-merchant-logout-js","42":"component---src-pages-merchant-orders-create-js","43":"component---src-pages-merchant-orders-dashboard-js","44":"component---src-pages-merchant-orders-review-js","45":"component---src-pages-merchant-orders-summary-js","46":"component---src-pages-merchant-orders-transactiondashboard-js","47":"component---src-pages-merchant-pos-initiate-js","48":"component---src-pages-merchant-pos-orders-summary-js","49":"component---src-pages-merchant-reports-index-js","50":"component---src-pages-merchant-selectmerchant-index-js","51":"component---src-pages-merchant-statements-settlementsummary-js","52":"component---src-pages-merchant-trainingguides-index-js","53":"component---src-pages-outcome-js","54":"component---src-pages-payment-complete-js","55":"component---src-pages-playground-checkout-js","56":"component---src-pages-playground-widget-js","57":"component---src-pages-playground-widget-testing-js","58":"component---src-pages-points-index-js","59":"component---src-pages-points-login-callback-js","60":"component---src-pages-points-login-index-js","61":"component---src-pages-purchase-initiate-js","62":"component---src-pages-rewards-index-js","63":"component---src-pages-rewards-link-index-js","64":"component---src-pages-rewards-login-callback-js","65":"component---src-pages-rewards-login-index-js","66":"component---src-pages-shopify-about-js","67":"component---src-pages-shopify-auth-js","68":"component---src-pages-shopify-install-js","69":"component---src-pages-shopify-payment-index-js","70":"component---src-pages-shopify-payment-outcome-js","71":"component---src-pages-shopify-payment-settings-js","72":"component---src-pages-token-index-js","73":"component---src-pages-token-login-callback-js","74":"component---src-pages-token-login-index-js","75":"component---src-pages-token-logout-js","76":"component---src-pages-wallet-index-js","77":"component---src-pages-wallet-login-callback-js","78":"component---src-pages-wallet-login-index-js","79":"component---src-pages-wallet-logout-js"}[chunkId]||chunkId) + "-" + {"0":"65e22599917d4e2cf9a3","1":"c091cbacc5bda877d9a4","2":"ab3c31de7fbf2a320024","3":"6d30b265aefb1269885b","4":"c5354ed31cdb69fb1a4d","5":"98b3dbec68a1aed2551c","6":"1304611d89eddfebe85a","7":"cccfc214365c184f4dac","8":"af4d84dadcc9fffaa32d","9":"a77593a9ddfe59053c5d","10":"9477839f80dedb1686c5","11":"6d9ee512f1131ccdaef8","12":"06b2793fb5c7eb36399a","13":"58c92959bd0c71f5d3ae","14":"632a2db2cba6b4538de3","15":"bbd707f5a7914eaa69bf","16":"e51a6656960685f38709","17":"6706ec9e6c8352225f7f","18":"459dee254e4b086d74a8","19":"c27ddf0c56bdaf560799","20":"a6f168a6e8dc304e891f","21":"8e734ef9452a7dca685f","22":"6ff4b5c42c7cb49eccbb","28":"4d2918e7505b42129107","29":"7f75549732ca54383495","30":"6e53b48ddbea850844b6","31":"f8b573a5b02c66792492","32":"911a342eee0e0fc29002","33":"df64f28bbe651a5220ae","34":"d7e467b240253f4c66ff","35":"e1f3c5a0c270592f5aec","36":"5bf00bd861ab5c57f5bd","37":"36fe27bbbb160b074280","38":"ce16c04d0e0a86486afc","39":"a5b65d328612b9478854","40":"ec11c7e2b94355634a85","41":"0c248edfd96256172799","42":"44fc7c2fdc5757255322","43":"770e30ecd02590ab00ee","44":"b16d52b3b65a65a7b149","45":"e16ad5429aebc6c3e3d4","46":"40ebf34b77f5498b8fa9","47":"541b74bfd2a2928843ff","48":"0e8b5de83cacefa635b1","49":"ca3149f2cbbfba5a9933","50":"921bddbd7d25aa7f9611","51":"87c07a4aaacf725470ac","52":"6123ab98e969ba4d90c5","53":"e16792438abc10c3bced","54":"c0e175f747cc7691b030","55":"bc0b5b97dd5ccd02d24e","56":"3953e327c598ffaf1cc6","57":"4e5e1c0803eeca0be317","58":"0323ca4d5b1cdb503ec0","59":"a5f3e7120d885a9d0857","60":"03648ea30e56e1844a50","61":"028168f8d911323873ed","62":"40947980da73202c440a","63":"55ca3039ae1a0a28f51f","64":"658c8d3c667222ba0c1c","65":"29239a60e02d0ca5e720","66":"84e7bb320273b77a465f","67":"7b0774ba814d38d41152","68":"84445b1b6ec908703373","69":"d770782b43de6928bca4","70":"d78bce33f2de58f337d0","71":"b8fed6189150f5f909d5","72":"f7e2a79feb88443b050d","73":"aad12897f2d558bb81d2","74":"0a3f727cbaf90e2fd4f6","75":"7f41f4df00a453d985cc","76":"eebfaa2964139ce229d4","77":"11ae1b58f9055211abb1","78":"f1562963b69c1d7656e5","79":"43d323708487b607617a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
